// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32C2m","colMin":"styles_colMin__2fBoP"};